import { SetStateAction } from "react";
import { t } from "i18next";
import { CateringServiceRow } from "../Domain/Types/FacilityService-row.types";
import { ServiceType } from "../../../../features/Booking-Form/typings/booking-service-administration.types";
import { FileObject } from "../../../../features/FileDropzone/typings/FileObject.type";

export function cateringRowValuesToFormData(
  value: Partial<CateringServiceRow>,
  rowOriginal: CateringServiceRow,
  userId: string,
  imageFile: { file: FileObject[] }
): FormData {
  const data = new FormData();

  data.append("userId", userId);

  data.append("id", String(value.id ? Number(value.id) : 1));
  data.append("serviceId", String(value.id ? Number(value.id) : 1));
  data.append("name", String(value.name));
  data.append("description", String(value.description));

  data.append("pricePerUnit", String(value.pricePerUnit));

  // serviceType
  data.append("serviceType", ServiceType.Catering);

  // when add photo - imageFile exists and null rowPic, valPic
  if (imageFile.file.length) data.append("file", imageFile.file[0].file);
  // when delete photo - value.picturePath : current path / rowOriginal.picturePath : undefined => not sending picturePath

  // photo stays
  if (value.picturePath && rowOriginal.picturePath)
    data.append("picturePath", String(value.picturePath));

  data.append("locationInventoryId", String(value.location?.id ?? 0));

  // permissions
  if (value.servicePermissions) {
    data.append(
      "permissions",
      JSON.stringify({
        companyIds: value.servicePermissions.companyIds ?? [],
        costCenterUnitIds: value.servicePermissions.costCenterUnitIds ?? [],
        userIds: value.servicePermissions.userIds ?? []
      })
    );
  }

  if (value.bookingLeadTime != null) {
    data.append("bookingLeadTime", String(value.bookingLeadTime));
  }

  return data;
}

export const checkCateringVal = (
  value: string,
  item: "name" | "description" | "pricePerUnit",
  validationErrors: Record<string, string | undefined>,
  setValidationErrors: (value: SetStateAction<Record<string, string | undefined>>) => void
) => {
  if (value === "") {
    setValidationErrors({
      ...validationErrors,
      [item]: undefined
    });
  } else {
    checkValueTypeLength(value, item, validationErrors, setValidationErrors);
  }
};

export const checkValueTypeLength = (
  value: string,
  item: "name" | "description" | "pricePerUnit",
  validationErrors: Record<string, string | undefined>,
  setValidationErrors: (value: SetStateAction<Record<string, string | undefined>>) => void
) => {
  const resetValidErr = () =>
    setValidationErrors({
      ...validationErrors,
      [item]: undefined
    });

  switch (item) {
    case "name": {
      if (value.length > 75) {
        setValidationErrors({
          ...validationErrors,
          [item]: t("Name cannot exceed 75 characters")
        });
      } else resetValidErr();
      break;
    }
    case "description": {
      if (value.length > 1000) {
        setValidationErrors({
          ...validationErrors,
          [item]: t("Description cannot exceed 1000 characters")
        });
      } else resetValidErr();
      break;
    }
    case "pricePerUnit": {
      // if the value is not number
      if (Number.isNaN(Number(value))) {
        setValidationErrors({
          ...validationErrors,
          [item]: t("Price Per Unit should be number")
        });
      }
      if (Number(value) < 0) {
        setValidationErrors({
          ...validationErrors,
          [item]: t("Price Per Unit should be larger than 0")
        });
      }

      if (checkIntegerDigits(value) > 7) {
        setValidationErrors({
          ...validationErrors,
          [item]: t("Price Per Unit cannot exceed 7 digits")
        });
      } else resetValidErr();
      break;
    }
  }
};

export const checkIntegerDigits = (value: string) => {
  const integerPart = value.split(".")[0]; // Get the part before the decimal
  const numberString = integerPart.replaceAll(/\D/g, ""); // Remove non-digit characters (if any)

  return numberString.length;
};
